import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Work from './pages/Work';
import ComingSoon from './pages/ComingSoon';
import About from './components/About';
import Press from './pages/Press';
import Contact from './components/Contact';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <Router>
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1 pt-20">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/work" element={<Work />} />
                <Route path="/work/:category" element={<ComingSoon />} />
                <Route path="/about" element={<About />} />
                <Route path="/press" element={<Press />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
